import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../../components";
import { Col, Row } from "antd";
import styles from "./AddVenue.module.css";
import Modal from "../../../../../../components/modal/Modal";
import { useEffect, useState, cloneElement, useRef } from "react";
import RoomImage from "../../../../../../assets/RoomImage.png";
import { EventPlanningMiddleware } from "../../../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../../Store/Actions/GeneralActions";

const addVenueSvg = (
  <svg
    width="215"
    height="250"
    viewBox="0 0 215 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M144.937 152.37C147.144 152.855 148.903 152.994 150.45 153.643C152.244 154.396 153.173 156.097 153.049 158.035C152.925 159.947 151.832 161.432 150.022 162.189C149.305 162.488 148.387 162.736 147.68 162.55C137.258 159.813 132.596 166.808 127.744 173.946C123.68 179.931 119.358 185.73 116.156 192.245C115.021 194.549 113.706 196.507 110.844 196.348C108.307 196.208 107.172 194.337 106.12 192.265C101.371 182.895 94.8678 174.714 88.6123 166.344C86.4413 163.437 84.1773 162.22 80.5932 162.535C76.9988 162.854 73.358 162.586 69.7378 162.591C66.6229 162.596 64.555 160.937 64.4519 157.994C64.3332 154.684 66.494 152.942 69.8719 152.937C72.012 152.932 74.1573 152.937 77.597 152.937C70.14 144.582 63.5184 137.134 56.8659 129.706C35.7068 106.073 30.2559 71.8528 43.2721 44.3384C43.7878 43.2509 44.2983 42.1633 44.845 41.0912C46.3663 38.1119 48.8262 36.8697 51.8069 38.4572C54.8495 40.0757 54.8702 42.756 53.3437 45.7044C48.1661 55.6988 45.4896 66.3118 45.9847 77.6103C46.686 93.7282 51.3686 108.537 62.0539 120.81C78.9224 140.18 96.5644 158.89 111.076 181.013C124.84 160.303 140.605 141.912 157.252 124.253C164.843 116.201 170.036 106.841 173.213 96.2796C186.549 51.9618 154.416 9.26257 108.58 10.5409C97.7402 10.845 87.6274 13.9428 78.2932 19.4838C75.0907 21.3858 71.5479 23.7156 69.0364 19.1436C66.8034 15.0819 70.1194 12.9738 73.2394 11.2367C98.0032 -2.55137 123.174 -3.36062 147.846 10.6749C172.676 24.8032 185.296 46.895 185.878 75.4918C185.971 80.1669 186.471 83.2853 191.463 84.9038C194.346 85.8367 196.883 88.3572 195.182 91.955C193.397 95.7075 190.391 95.7848 187.188 93.4807C185.146 92.0117 184.12 92.3725 183.532 94.9858C179.839 111.398 170.944 124.727 159.139 136.443C154.183 141.36 149.81 146.865 144.937 152.37Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M147.188 59.833C138.818 49.1943 124.832 47.983 113.709 57.2455C111.44 59.132 110.424 59.0031 108.454 57.0805C104.272 53.0034 99.0733 51.0344 93.1943 50.9983C83.592 50.9519 74.7787 57.1269 71.4473 66.2399C68.085 75.42 70.6944 85.3732 78.7548 91.6152C88.5995 99.2489 98.5525 106.692 106.835 116.109C109.661 119.325 112.791 119.176 115.576 115.99C123.425 107.011 132.841 99.8571 142.242 92.6358C153.516 83.9815 155.449 70.3326 147.188 59.833ZM137.24 84.2856C128.948 90.6049 120.48 96.7232 113.312 104.367C111.687 106.104 110.558 106.073 108.949 104.357C101.786 96.7078 93.2253 90.7029 85.0411 84.2444C79.7191 80.0435 78.3938 74.3324 80.9052 68.7295C83.3342 63.3174 88.6871 60.1732 94.4578 60.7763C100.388 61.3948 105.153 65.6833 106.107 71.9923C106.633 75.4818 107.139 78.6209 111.44 78.4405C115.375 78.2755 115.648 75.1932 116.143 71.9974C117.288 64.6369 123.693 59.9515 130.794 60.8072C137.333 61.5958 142.567 67.4667 142.511 74.8942C142.361 78.2188 140.628 81.7032 137.24 84.2856Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M116.226 211.702C107.897 209.295 98.5267 212.687 94.6177 220.557C92.689 224.444 90.6262 225.866 86.5728 225.413C82.9784 225.011 79.7862 226.109 79.8688 230.31C79.9461 234.531 83.2569 235.382 86.7843 235C90.554 234.593 92.6375 235.665 94.4579 239.479C98.2637 247.453 107.588 251.113 115.859 248.86C124.482 246.51 130.356 239.072 130.448 230.397C130.541 221.691 124.833 214.192 116.226 211.702ZM111.419 239.845C106.035 240.021 101.394 235.443 101.482 230.042C101.569 224.866 105.953 220.552 111.13 220.557C116.287 220.563 120.691 224.903 120.769 230.062C120.846 235.222 116.592 239.68 111.419 239.845Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M205.237 124.175C205.541 117.49 204.345 112.263 201.807 107.367C200.142 104.145 199.538 101.032 203.416 99.2278C207.429 97.3671 209.223 100.372 210.693 103.403C213.71 109.645 215.303 116.217 214.947 123.17C214.741 127.165 214.937 132.288 209.321 131.984C203.829 131.685 205.046 126.773 205.237 124.175Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M174.938 162.617C171.467 162.921 168.559 161.761 168.363 158.102C168.146 154.035 171.117 152.947 174.835 152.865C180.977 152.731 186.665 150.88 191.714 147.324C194.627 145.267 197.742 144.066 200.011 147.669C202.229 151.179 199.872 153.566 196.943 155.53C190.264 160.004 182.874 162.158 174.938 162.617Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M46.8553 157.736C46.3448 160.607 44.8647 162.54 41.7293 162.56C34.4785 162.607 27.9756 164.802 22.0657 168.983C19.6316 170.704 16.9602 170.699 15.1811 168.122C13.2627 165.344 14.2167 162.849 16.8829 160.89C24.0717 155.617 32.1476 153.107 41.0176 152.911C44.3799 152.844 46.2313 154.478 46.8553 157.736Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M9.70052 192.91C9.47877 198.456 10.8247 203.662 13.362 208.538C14.9761 211.641 15.2082 214.471 11.7943 216.239C8.25657 218.069 6.22471 215.857 4.69825 212.878C1.13992 205.935 -0.458743 198.59 0.113683 190.807C0.371532 187.256 0.990371 183.374 5.48726 183.524C10.1543 183.678 10.3297 187.436 9.80366 191.116C9.716 191.704 9.72631 192.312 9.70052 192.91Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M44.9973 235.047C41.0367 235.217 35.8281 235.032 30.733 233.717C27.5254 232.893 24.9263 231.223 25.8545 227.465C26.69 224.094 29.5469 223.419 32.5792 224.218C39.4999 226.032 46.5444 225.228 53.5372 225.342C57.0131 225.398 59.7205 226.46 59.6998 230.243C59.6792 234.022 56.9563 235.192 53.4857 235.073C51.0825 234.98 48.669 235.047 44.9973 235.047Z"
      className={styles.addVenueSvgPath}
    />
    <path
      d="M57.6392 35.7559C55.8858 35.8538 54.5193 35.0601 53.5652 33.7044C52.2863 31.8849 52.245 29.7201 53.591 28.1222C56.0148 25.2512 58.7222 22.5967 61.4812 20.0298C62.9097 18.6999 64.7249 18.6896 66.4628 19.7566C68.1389 20.7823 68.9949 22.2152 68.866 24.21C68.6958 26.8955 60.2229 35.6167 57.6392 35.7559Z"
      className={styles.addVenueSvgPath}
    />
  </svg>
);

const SquareIcon = ({ selectedValue }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 107 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.638672"
        y="0.970703"
        width="105.867"
        height="88.9284"
        rx="5"
        className={
          selectedValue ? styles.selectedOuter : styles.unselectedOuter
        }
      />
      <rect
        x="1.13867"
        y="1.4707"
        width="104.867"
        height="87.9284"
        rx="4.5"
        stroke="#E4E4E4"
        stroke-opacity="0.6"
      />
      <rect
        x="32.3984"
        y="24.2607"
        width="42.3469"
        height="42.3469"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
    </svg>
  );
};

const RectangleIcon = ({ selectedValue }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 107 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.148438"
        y="0.661133"
        width="105.867"
        height="88.9284"
        rx="5"
        className={
          selectedValue ? styles.selectedOuter : styles.unselectedOuter
        }
      />
      <rect
        x="0.648438"
        y="1.16113"
        width="104.867"
        height="87.9284"
        rx="4.5"
        stroke="#E4E4E4"
        stroke-opacity="0.6"
      />
      <rect
        x="12.8516"
        y="23.2656"
        width="80.459"
        height="42.3469"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
    </svg>
  );
};

const SmoothRectangleIcon = ({ selectedValue }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 107 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.660156"
        y="0.661133"
        width="105.867"
        height="88.9284"
        rx="5"
        className={
          selectedValue ? styles.selectedOuter : styles.unselectedOuter
        }
      />
      <rect
        x="1.16016"
        y="1.16113"
        width="104.867"
        height="87.9284"
        rx="4.5"
        stroke="#E4E4E4"
        stroke-opacity="0.6"
      />
      <rect
        x="13.3633"
        y="12.6772"
        width="80.459"
        height="63.5203"
        rx="15"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
    </svg>
  );
};

const LShapeIcon = ({ selectedValue }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 107 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.167969"
        y="0.661133"
        width="105.867"
        height="88.9284"
        rx="5"
        className={
          selectedValue ? styles.selectedOuter : styles.unselectedOuter
        }
      />
      <rect
        x="0.667969"
        y="1.16113"
        width="104.867"
        height="87.9284"
        rx="4.5"
        stroke="#E4E4E4"
        stroke-opacity="0.6"
      />
      <rect
        x="12.873"
        y="44.4419"
        width="80.459"
        height="29.6428"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
      <rect
        x="95.4492"
        y="14.7979"
        width="59.2856"
        height="29.6428"
        transform="rotate(90 95.4492 14.7979)"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
    </svg>
  );
};

const PlusIcon = ({ selectedValue }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 107 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.679688"
        y="0.661133"
        width="105.867"
        height="88.9284"
        rx="5"
        className={
          selectedValue ? styles.selectedOuter : styles.unselectedOuter
        }
      />
      <rect
        x="1.17969"
        y="1.16113"
        width="104.867"
        height="87.9284"
        rx="4.5"
        stroke="#E4E4E4"
        stroke-opacity="0.6"
      />
      <rect
        x="19.7363"
        y="31.7334"
        width="67.755"
        height="29.6428"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
      <rect
        x="66.3184"
        y="16.9146"
        width="59.2856"
        height="25.4081"
        transform="rotate(90 66.3184 16.9146)"
        className={
          selectedValue ? styles.selectedInner : styles.unselectedInner
        }
      />
    </svg>
  );
};

const VenueModal = ({ setVenueCreated }) => {
  const [selectedType, setSelectedType] = useState();
  const [step, setStep] = useState(1);
  const [venueName, setvenueName] = useState("");
  const [venueimage, setvenueimage] = useState();
  const imgref = useRef();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { state } = useLocation();

  const venueTypes = [
    {
      id: 1,
      component: <SquareIcon />,
    },
    {
      id: 2,
      component: <RectangleIcon />,
    },
    {
      id: 3,
      component: <SmoothRectangleIcon />,
    },
    {
      id: 4,
      component: <LShapeIcon />,
    },
    {
      id: 5,
      component: <PlusIcon />,
    },
  ];

  useEffect(() => { 
    setSelectedType(venueTypes[0].id);
  }, []);

  const createVenue = () => {
    if (venueimage) {
      // setSubmit(true);
      dispatch(
        EventPlanningMiddleware.createEventVenue({
          id: state?.eventData?.id,
          name: venueName,
          image: venueimage,
        })
      )
        .then(() => {
          setVenueCreated(true);
          // setSubmit(false);
          // setuploadModal(false);
        })
        .catch(() => {
          // setSubmit(false);
          // setuploadModal(false);
        });
    } else {
      dispatch(
        showAlert({
          type: "Error",
          message: "Select Venue Image",
        })
      );
      return;
    }
  };

  return (
    <>
      <Row className={styles.venueModalTitleRow}>
        <TextComponent textClass={styles.venueModalTitle}>
          Add Venue
        </TextComponent>
      </Row>
      {step === 1 ? (
        <>
          <Row className={styles.venueModalTypesRow}>
            <TextComponent>Types of Venue</TextComponent>
          </Row>
          <Row style={{ justifyContent: "space-between" }}>
            {venueTypes?.map((venue) => {
              return (
                <Col
                  key={venue.id}
                  className={styles.venueTypeCol}
                  onClick={() => setSelectedType(venue.id)}
                >
                  {cloneElement(venue.component, {
                    selectedValue: venue.id === selectedType,
                  })}
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col xs={24}>
              <InputField
                label="Venue Name"
                placeholder="Ceremony Venue"
                onChange={(e) => setvenueName(e.target.value)}
              />
            </Col>
          </Row>
          <Row className={styles.btnRow}>
            <Col xs={24}>
              <SubmitButton
                title="Next"
                onClick={() => {
                  if (!venueName) {
                    dispatch(
                      showAlert({
                        type: "Error",
                        message: "Enter Venue Name",
                      })
                    );
                    return;
                  }
                  setStep((prev) => prev + 1);
                }}
              />
            </Col>
          </Row>
        </>
      ) : (
        <Row className={styles.contentRow}>
          <Col>
            <TextComponent textClass={styles.title}>Upload Image</TextComponent>
          </Col>
          <Col>
            <TextComponent textClass={styles.desc}>
              Upload event venue picture, which showcase venue area.
            </TextComponent>
          </Col>
          <Col>
            <img
              src={venueimage ? URL.createObjectURL(venueimage) : RoomImage}
              alt=""
              className={styles.img}
              onClick={() => imgref.current.click()}
            />
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              ref={imgref}
              onChange={(e) => setvenueimage(e.target.files[0])}
            />
          </Col>
          <Col>
            <SubmitButton title="Upload Image" onClick={createVenue} />
          </Col>
        </Row>
      )}
    </>
  );
};

const AddVenue = ({ setVenueCreated }) => {
  const [venueModalOpen, setVenueModalOpen] = useState(false);

  return (
    <>
      <Row className={styles.header}>
        <TextComponent textClass={styles.headerText}>Venue</TextComponent>
      </Row>
      <Row className={styles.textIconRow}>
        <Col>
          <TextComponent textClass={styles.iconText}>
            Please Add Venue
          </TextComponent>
        </Col>
        <Col>{addVenueSvg}</Col>
      </Row>
      <Row className={styles.rightRow}>
        <Box
          boxClass={styles.addVenueBox}
          onClick={() => setVenueModalOpen(true)}
        >
          <TextComponent>+ Add Venue</TextComponent>
        </Box>
      </Row>
      <Modal
        isModalOpen={venueModalOpen}
        setIsModalOpen={setVenueModalOpen}
        closable={true}
        className={styles.modalContent}
      >
        <VenueModal setVenueCreated={setVenueCreated} />
      </Modal>
    </>
  );
};

export default AddVenue;
